/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowFounderContactDtoSchema } from "./dealflowFounderContactDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowContactDtoSchema = z.object({
  get founders() {
    return z.array(dealflowFounderContactDtoSchema).optional();
  },
  companyLinkedin: z.optional(z.string()),
  email: z.optional(z.string()),
  phone: z.optional(z.string()),
});
